import state from './moduleUserState'
import actions from './moduleUserActions'
import getters from './moduleUserGetters'
import mutations from './moduleUserMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}

